import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class Network extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <div className="container mt-4">
        <div className="spare-dvs vh-100 align-items-start">
          <div className="w-100 float-left">
            <div className="ntwrk-dvs">
              <h1>{t('network:welcome')}</h1>
            </div>

            <div className="terms-dv">
              <h6>{t('network:termsTitle')}</h6>
              <p>{t('network:termsBlurb')}</p>

              <Link to="/dashboard">{t('network:confirm')}</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(['network'])(Network);
